import { useQuery } from '@tanstack/react-query';
import { BusinessTripConfigurationModel } from './types';
import { QUERY_KEY_SETTINGS_BUSINESS_TRIP, SETTINGS_QUERY_ALWAYS_REVALIDATE } from '@/lib/api/constants'
import { businessTripConfigurationMock } from './mock';
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { getConfigurationBusinessTrips } from './getConfigurationBusinessTrips';
import { toPriorityCountries } from './priorityCountry';

/**
 * Fetches basic company settings.
 */
export function useQueryConfigurationBusinessTrips(companyId: string) {
  return useQuery<BusinessTripConfigurationModel>({
    queryKey: [QUERY_KEY_SETTINGS_BUSINESS_TRIP, companyId],
    queryFn: async () => {
      if(COMPANY_API_SETTINGS_MOCKED){
        return businessTripConfigurationMock
      }
      const { data } = await getConfigurationBusinessTrips({ companyId })
      return {
        ...data,
        minDrivingMinutesForStartOnDriving:
          data.minDrivingMinutesForStartOnDriving ?? 0,
        minDrivingMinutesForEndOnDriving:
          data.minDrivingMinutesForEndOnDriving ?? 0,
        priorityCountries: toPriorityCountries(data.priorityCountries),
      }
    },
    enabled: !!companyId,
    ...SETTINGS_QUERY_ALWAYS_REVALIDATE,
  });
}
